function historyEvent() {
  const history = localStorage.getItem("@history");
  if (history) {
    return JSON.parse(history)
  }

  return []
}

function historyCollectionsEvent() {
  const history = historyEvent();
  return history.filter(e => e.includes("collections"));
}


function homeEventsClick (firstLevelItem, secondLevelItem = "") {
  dataLayer.push({
    event: "home_interactions",
    first_level: firstLevelItem,
    second_level: secondLevelItem
  });
}

function footerEventsClick (firstLevelItem, secondLevelItem = "", thirdLevelItem = "") {
  dataLayer.push({
    event: "footer_interactions",
    first_level: firstLevelItem,
    second_level: secondLevelItem,
    third_level: thirdLevelItem
  });
  
}

function plpEventsClick (firstLevelItem, secondLevelItem = "", thirdLevelItem = "", pageName="") {
  dataLayer.push({
    event: "plp_interactions",
    first_level: firstLevelItem,
    second_level: secondLevelItem,
    third_level: thirdLevelItem,
    page: pageName
  });
}

function pdpEventsClick (firstLevelItem, secondLevelItem = "", thirdLevelItem = "", productName="", generalObject = null) {
  const collections = historyCollectionsEvent();
  

  dataLayer.push({
    event: "pdp_interactions",
    first_level: firstLevelItem,
    second_level: secondLevelItem,
    third_level: thirdLevelItem,
    product: productName
  });
  if (generalObject) {
    localStorage.removeItem("@history");
    localStorage.setItem(`@history-${generalObject.id}`, JSON.stringify(collections));
  }
  
}
